import React, { useContext, createContext, useState, ReactNode } from 'react'

export const NavigationContext = createContext<ValueType>({})

interface NavigationProviderProps {
  value: object
  children: ReactNode | ReactNode[]
}

export type NavigationType = Record<string, any>

export interface ValueType {
  navigation?: NavigationType
  update?: (id: string, value: any) => void
}

export default function NavigationProvider({
  value,
  children,
}: NavigationProviderProps) {
  const [navigation, setNavigation] = useState({})

  const update = (id, val) => {
    setNavigation((navigation) => ({ ...navigation, [id]: val }))
  }

  const processedValue: ValueType = {
    navigation: { ...value, ...navigation },
    update,
  }

  return (
    <NavigationContext.Provider value={processedValue}>
      {children}
    </NavigationContext.Provider>
  )
}

export function useNavigation() {
  return useContext(NavigationContext)
}
